import React from 'react';
import { useParams } from 'react-router-dom';
import Terms from './termsofuse';
import TermsPerm from './termsofuseperm';
import TermsArchive from './termsofusearchive';

export function TermsOfUse() {
  return (
    <div>
      <Terms />
    </div>
  );
}

export function TermsOfUsePerm() {
  return (
    <div>
      <TermsPerm />
    </div>
  );
}

export function TermsOfUseArchive() {
  const params = useParams();
  const districtName = params.districtName;
  return (
    <div>
      <TermsArchive districtName={districtName} />
    </div>
  );
}

export default TermsOfUse;
